<template>
    <v-app id="inspire">
        <v-navigation-drawer
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
                dark
                v-model="drawer"
                v-if="this.$store.state.signedIn"
        >
            <v-list
                    dense
                    nav
            >
                <v-list-item two-line>
                    <v-list-item-avatar color="indigo">
                        <span class="white--text headline">{{account.firstname[0]}}</span>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{account.firstname}} {{account.lastname}}</v-list-item-title>
                        <v-list-item-subtitle>
                            {{role}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item
                        v-for="item in items"
                        :key="item.text"
                        link
                        :to="item.link"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="primary darken-1"
                dark
        >
            <v-app-bar-nav-icon v-if="this.$store.state.signedIn" @click.stop="drawer = !drawer"/>
            <v-toolbar-title
                    style="width: 300px"
                    class="ml-0 pl-4"
            >
                <span class="hidden-sm-and-down" @click="$router.push('/')" style="cursor: pointer">BenevApp Verwaltung</span>
            </v-toolbar-title>
            <v-spacer/>
            <v-btn v-if="this.$store.state.signedIn" @click="signOut">Logout</v-btn>
        </v-app-bar>
        <v-content>
            <v-container
                    class="fill-height"
                    style="align-items: baseline"
                    fluid
            >
                <router-view></router-view>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import {accountService} from "@/services/accountService";

    export default {
        name: 'App',

        components: {},

        data: () => ({
            drawer: true,
        }),
        methods: {
          signOut() {
            accountService.signOut();
          }
        },

        computed: {
            account() {
                return JSON.parse(localStorage.getItem("account"));
            },
            role() {
                return JSON.parse(localStorage.getItem("account")).role.name;
            },
            items() {
                let items = [];
                items.push(
                    {icon: "person", text: "Benutzer", link: "/users"}
                );
                items.push(
                    {icon: "assignment", text: "Leistungen", link: "/services"}
                );
              items.push(
                  {icon: "mdi-file-document", text: "Auszüge", link: "/reports"}
              );
                if(this.account.roleId !== 1)
                    items.push(
                        {icon: "check", text: "Leistungen visieren", link: "/confirm"}
                    );
                if(this.account.roleId === 4)
                  items.push(
                      {icon: "mdi-key", text: "Api Keys", link: "/apikeys"}
                  );
                return items;
            }
        },
    };
</script>
